import { createEventHandler } from '@wix/tpa-settings';
import { AppSettings } from '@wix/search-settings-client';

import {
  IControllerConfig,
  ControllerFactory,
} from '../../../../lib/platform.types';
import { SearchResultsControllerStore } from './searchResultsControllerStore';
import { createSlotVeloAPIFactory } from '@wix/widget-plugins-ooi/velo';
import { SLOTS } from '../../../../lib/slots';
import { SearchDocumentType } from '@wix/client-search-sdk';
import { ProductsSlot } from './products';

interface ISettingsEvents {
  previewStateChange: {
    shouldHaveSearchResults: boolean;
  };
  appSettingsChange: AppSettings;
  activeDocumentTypeChange: SearchDocumentType;
}

export const searchResultsControllerFactory: ControllerFactory = async (
  params,
) => {
  const { config, isProductSlotInstalled } = params;

  const eventHandler = createEventHandler<ISettingsEvents>(
    config.publicData.COMPONENT,
  );

  const controllerStore = new SearchResultsControllerStore(params);

  eventHandler.on(
    'previewStateChange',
    (value: ISettingsEvents['previewStateChange']) => {
      controllerStore.updateDemoMode(value);
    },
  );

  eventHandler.on(
    'activeDocumentTypeChange',
    (value: ISettingsEvents['activeDocumentTypeChange']) => {
      controllerStore.updateDemoActiveDocumentType(value);
    },
  );

  eventHandler.on('appSettingsChange', (appSettings: AppSettings) => {
    controllerStore.updateSettings(appSettings);
  });

  eventHandler.onReset(() => {
    controllerStore.updateDemoMode({
      shouldHaveSearchResults: true,
    });
  });

  return {
    async pageReady() {
      if (isProductSlotInstalled) {
        const slotAPIFactory = createSlotVeloAPIFactory(params);
        const productsSlot = slotAPIFactory.getSlotAPI(
          SLOTS.products.id,
        ) as ProductsSlot;
        await controllerStore.setInitialStateWithSlots(productsSlot);
      } else {
        await controllerStore.setInitialState(isProductSlotInstalled);
      }
      return;
    },

    updateConfig($w, updatedConfig) {
      const { publicData } = updatedConfig as IControllerConfig['config'];
      eventHandler.notify(publicData.COMPONENT); // Trigger events
      // To update widget in editor when settings change
      controllerStore.updateSettings();
    },
  };
};
